import { useEffect, useContext, useState, useRef } from "react";
import { TokenVerificationLoggedin, BlockAdmin, BlockAM } from "../../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
// import { useLocation } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import configData from "../../config/config.json";
// import { notifyfailure } from "../../utils/toast";
import { Table, Select, Col, Row, Pagination, Input, /*Modal, Checkbox,*/ Button, Radio } from 'antd';
// import HoverCloseIcon from '../../assets/images/icons/hover_close.svg';
import tagRomoveIcon from '../../assets/images/icons/tag_close_icon.svg';
// import filterIcon from '../../assets/images/icons/filter.svg';
import { Link } from 'react-router-dom'
import FullLoader from "../../assets/images/full-page-loader.gif"
import prevIcon from '../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../assets/images/icons/chevron-right.svg';
import { jwtDecode } from "jwt-decode";
import noData from '../../assets/images/data-graph/no-data.svg';
import TableLoader from "../TableLoader";
import errorData from '../../assets/images/data-graph/error-data.svg';
import Dropdown from 'react-bootstrap/Dropdown';

const UserSyncReport = () => {
    const loadingContext = useContext(LoadingContext);
    const [apiCall, setApicall] = useState(false)
    const [/* checkRole */, setCheckRole] = useState("admin")
    const [filter, setFilter] = useState("date")
    const [total, setTotal] = useState([])


    const columnsDate = [
        {
            title: "Date",
            dataIndex: "date",
            width: 150,
            key: "date",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            defaultSortOrder: 'descend'
        },
        {
            title: "Publisher",
            "children": [
                {
                    title: "Sync Attempts",
                    dataIndex: "us_ssp_sync",
                    width: 150,
                    key: "us_ssp_sync",
                    sortDirections: ['ascend', 'descend', 'ascend'],
                    sorter: true,
                },
                {
                    title: "Successful Syncs",
                    dataIndex: "us_ssp_sync_success",
                    width: 150,
                    key: "us_ssp_sync_success",
                    sortDirections: ['ascend', 'descend', 'ascend'],
                    sorter: true,
                },

            ]

        },
        {
            title: "Remote Feed",
            "children": [
                {
                    title: "Sync Attempts",
                    dataIndex: "us_dsp_sync",
                    width: 150,
                    key: "us_dsp_sync",
                    sortDirections: ['ascend', 'descend', 'ascend'],
                    sorter: true,
                },
                {
                    title: "Successful Syncs",
                    dataIndex: "us_dsp_sync_success",
                    width: 150,
                    key: "us_dsp_sync_success",
                    sortDirections: ['ascend', 'descend', 'ascend'],
                    sorter: true,
                },

            ]

        },
    ];

    const columnsZone = [
        {
            title: "Zone Id",
            dataIndex: "zone_id",
            width: 150,
            key: "zone_id",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,

        },
        {
            title: "Zone Name",
            dataIndex: "zone",
            width: 150,
            key: "zone",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
        },
        {
            title: "Zone Type",
            dataIndex: "zone_type",
            width: 150,
            key: "zone_type",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
        },
        {
            title: "Publisher",
            "children": [
                {
                    title: "Sync Attempts",
                    dataIndex: "us_ssp_sync",
                    width: 150,
                    key: "us_ssp_sync",
                    sortDirections: ['ascend', 'descend', 'ascend'],
                    sorter: true,
                    defaultSortOrder: 'descend'
                },
                {
                    title: "Successful Syncs",
                    dataIndex: "us_ssp_sync_success",
                    width: 150,
                    key: "us_ssp_sync_success",
                    sortDirections: ['ascend', 'descend', 'ascend'],
                    sorter: true,
                },

            ]

        },
        {
            title: "Remote Feed",
            "children": [
                {
                    title: "Sync Attempts",
                    dataIndex: "us_dsp_sync",
                    width: 150,
                    key: "us_dsp_sync",
                    sortDirections: ['ascend', 'descend', 'ascend'],
                    sorter: true,
                },
                {
                    title: "Successful Syncs",
                    dataIndex: "us_dsp_sync_success",
                    width: 150,
                    key: "us_dsp_sync_success",
                    sortDirections: ['ascend', 'descend', 'ascend'],
                    sorter: true,
                },

            ]

        },
    ];

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)
    const [tabChangeLoad, setTabChangeLoad] = useState(true)

    const [page, setPage] = useState({
        current: 1,
        pageSize: 50,
        total: 10,
    });


    const [sort, setSort] = useState({
        name: "date",
        type: "descend"
    });

    const [search, setSearch] = useState("")


    //-----------------------------filter related code ----------------------------------//
    const [filterShow, setFilterShow] = useState(false)
    const [filterApply, setFilterApply] = useState({
        zoneType: []

    });
    const [filterApplyApiCall, setFilterApplyApiCall] = useState({
        zoneType: []
    });


    useEffect(() => {
        if (!initialLoad) {
            let tempPage = page
            tempPage.current = 1
            setPage(tempPage);
            setApicall(!apiCall)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterApplyApiCall])

    function handleFilterApply(type, value) {
        let tempFilterApply = { ...filterApply }

        if (type === "zoneType") {
            const index = filterApply.zoneType.indexOf(value);
            if (index === -1) {
                tempFilterApply.zoneType.push(value);
            } else {
                tempFilterApply.zoneType.splice(index, 1);
            }

        }
        setFilterApply(tempFilterApply)
    }

    const dropdownRef = useRef(null);

    // Use a ref to track the current state of filterShow
    const filterShowRef = useRef(filterShow);

    useEffect(() => {
        // Update the ref whenever filterShow changes
        filterShowRef.current = filterShow;
    }, [filterShow]);

    useEffect(() => {
        // Function to handle clicks outside the dropdown
        function handleClickOutside(event) {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                filterShowRef
            ) {

                const selectElement = document.getElementById('adcodeSelect'); // assuming this is the parent of the actual dropdown
                if (!selectElement?.closest('.ant-select')?.classList?.contains('ant-select-open')) {

                    let temp = JSON.parse(JSON.stringify(filterApplyApiCall));

                    setFilterApply(prevState => ({
                        ...prevState,
                        zoneType: temp.zoneType,
                    }));

                    setFilterShow(false);
                }
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // }, [dropdownRef, filterShow, filterApplyApiCall, setFilterApply, setFilterShow]);
    });

    //-----------------------------filter related code ----------------------------------//

    const getData = () => {
        setLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");


            let dateRangeCall = {
                startDate: dateRange?.start.format('YYYY-MM-DD'),
                endDate: dateRange?.end.format('YYYY-MM-DD')
            };

            axios
                .post(configData.SERVER_URL + `report/userSyncReports`, {
                    "filter": {
                        "dimensions": [filter],
                        "zone_type": filterApplyApiCall.zoneType,
                        "pagination": { "page": page.current, "limit": page.pageSize },
                        "sort": { "field": sort.name, "ord": sort.type === "" ? "" : sort.type === "ascend" ? 1 : -1 }
                    },
                    "date": dateRangeCall
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setData(response.data.data.adkRowData)

                    if (response.data.data.adkRowData.length > 0) {
                        let tempPage = { ...page }
                        tempPage.total = response.data.data?.totalRecords
                        setPage(tempPage)

                        setTotal(response.data.data.totalData)
                    }
                    else {
                        setTotal([])
                    }


                    setLoading(false)
                    setInitialLoad(false)
                    setTabChangeLoad(false)
                })
                .catch((error) => {
                    setData([])
                    setLoading(false)
                    setInitialLoad(false)
                    setTabChangeLoad(false)
                    setTotal([])

                });
        }

    }

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()
        BlockAM()
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let checkRole = jwtDecode(token).role;
            setCheckRole(checkRole)
        }
        getData()
        loadingContext.done()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingContext]);



    useEffect(() => {
        if (!initialLoad) {
            getData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiCall])

    // useEffect(() => {
    //     if (!initialLoad) {
    //         const delayDebounceFn = setTimeout(() => {
    //             let tempPage = page
    //             tempPage.current = 1
    //             setPage(tempPage);
    //             setApicall(!apiCall)
    //         }, 400); // 500ms delay
    //         // Cleanup function to clear the timeout if query changes
    //         return () => clearTimeout(delayDebounceFn);
    //     }
    // }, [search]);

    const filteredData = search && filter === "zone"
        ? data.filter(
            (item) =>
                item.zone_id?.toString().toLowerCase().includes(search.toLowerCase()) ||
                item.zone?.toLowerCase().includes(search.toLowerCase()) ||
                item.zone_type?.toString().toLowerCase().includes(search.toLowerCase())
        )
        : data;


    function handleTabChange(event) {
        let data = event.target.value
        if (filter !== event.target.value) {
            setTabChangeLoad(true)
        }
        setFilter(data)

        let tempPage = page
        tempPage.current = 1
        tempPage.total = 10
        setPage(tempPage)

        setSearch("")
        if (data === "date") {
            setSort({
                name: "date",
                type: "descend"
            })
        }
        else {
            setSort({
                name: "us_ssp_sync",
                type: "descend"
            })
        }

        resetSorter()
        setApicall(!apiCall)


    }

    const resetSorter = () => {
        setTimeout(() => {
            document.querySelectorAll('th[aria-sort]').forEach(th => {
                th.removeAttribute('aria-sort');
            });

            document.querySelectorAll('span[aria-label="caret-up"]').forEach(span => {
                span.classList.remove('active');
            });

            document.querySelectorAll('span[aria-label="caret-down"]').forEach(span => {
                span.classList.remove('active');
            });

        }, 0);

    };

    const handleTableChange = (pagination, filters, sorter) => {
        setSort({ name: sorter.field, type: sorter.order });
        setApicall(!apiCall)
    };

    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = 1
            }
        }

        setPage(tempPage);
        setApicall(!apiCall)
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };

    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>

                        <div className='float_text_div'>

                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>

                            </div>
                        </div>
                    </div>
                    :

                    (filterApplyApiCall.zoneType.length > 0) && loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>

                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
                        :
                        (filterApplyApiCall.zoneType.length > 0) && !loading ?
                            <div className='no_data_screen'>
                                <div className='text-center'>
                                    <img src={errorData} className='' alt="" />
                                    <div className='float_text_div'>

                                    </div>
                                </div>
                            </div>
                            :

                            loading ?
                                <div className='no_data_screen'>
                                    <div className='text-center'>

                                        <div className='float_text_div'>

                                        </div>
                                    </div>
                                </div>
                                :
                                <div className='no_data_screen' >
                                    <div className='text-center'>
                                        <img src={noData} className='' alt="" />
                                        <div className='float_text_div'>

                                        </div>
                                    </div>
                                </div>
            }
            </>

    };

    // eslint-disable-next-line no-unused-vars
    const components = {
        header: {
            wrapper: (props) => (
                <thead {...props}>
                    {props.children}
                </thead>
            ),
        },

        body: {
            wrapper: (props) => (
                <tbody {...props}>
                    {loading ? (
                        <>
                            <div className='loader_top_space'>
                                <div className="inside_table_two_loader">
                                    <img src={FullLoader} className="" alt="" />
                                </div>
                            </div>


                        </>
                    ) : (
                        props.children
                    )}
                </tbody>
            ),
        },
    };

    // ///////////////////date range picker code ////////////////////////
    // const [dateRange, setDateRange] = useState({
    //     start: moment().subtract(1, 'days'),
    //     end: moment().subtract(1, 'days'),
    // });
    const [dateRange, setDateRange] = useState({
        start: moment().startOf('month'),
        end: moment(),
    });


    // const [labelName, setLabelName] = useState("Yesterday");
    // const { start, end } = dateRange;
    // const label =
    //     start?.format('DD/MM/YYYY') + ' - ' + end?.format('DD/MM/YYYY');

    const datepickerRef = useRef(null);

    const [hasClass, setHasClass] = useState(false);

    useEffect(() => {
        const checkClass = () => {
            const daterangepicker = document.querySelector(".daterangepicker");
            if (daterangepicker && window.getComputedStyle(daterangepicker).display === "block") {
                setHasClass(true);
            } else {
                setHasClass(false);
            }
        };

        // Check initially
        checkClass();

        // Observe DOM changes
        const observer = new MutationObserver(checkClass);
        observer.observe(document.body, { attributes: true, childList: true, subtree: true });

        return () => observer.disconnect();
    });

    // ///////////////////////////////////////////////////////////////



    return (
        <>


            <div className="container_box--wrapper pt_header"
            >
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">
                        User Sync Report
                    </h1>


                </div>

                <div className="d_flex justify_content_between w_100 mb_10">
                    {!initialLoad &&
                        <div className="radios_btns --radios_btns_new">
                            <Radio.Group
                                className='radio_btn--group mb-0'
                                value={filter}
                                onChange={handleTabChange}
                            >
                                <Radio.Button value="date">Date</Radio.Button>
                                <Radio.Button value="zone">Zone</Radio.Button>

                            </Radio.Group>
                        </div>
                    }

                    {/* {!initialLoad &&
                            <div className="custom_filter_design_d2" style={{ marginLeft: "10px" }}>
                              {filter === "all" &&
                                <div className="export_btn_hover_d2">
                                  {data.length === 0 ?
                                    <Button
                                      className="export_btn_d2"
                                    >
                                      <img src={mediaKitIcon2} alt='' />
                                      Export
                                    </Button>
                                    :
                                    <>
                                      {exportLoading ?
                                        <Button
                                          className="export_btn_d2"
                                        >
                                          <img
                                            src={FullLoader}
                                            alt="USP"
                                            height={15}
                                            width={15}
                                            className="loader_icon"
                                          />
                                          Export
                                        </Button>
                                        :
                                        <Button
                                          className="export_btn_d2"
                                          onClick={getDataExport}
                                        >
                                          <img src={mediaKitIcon2} alt='' />
                                          Export
                                        </Button>
                                      }
                                    </>
                                  }
                                </div>
                              }
                           
                            </div>
                          } */}
                </div>
                <div className={filteredData.length > 0 ? "table_and_filter_div --without_filter_div" : "table_and_filter_div --without_filter_div --no_data_div_height_with_tabs"}>
                    <div className="table_area_div">
                        <div className="searchbar_with_btns">
                            <div className="form_content_block--group justify-content-between d_flex mb-0 custom_filter_design_d2 --new_layout_design_btn">
                                {!initialLoad && !tabChangeLoad &&

                                    <>
                                        <div>

                                            {filter === "zone" &&
                                                <Input
                                                    type='text'
                                                    className='form_control basic md search_input w_table_search'
                                                    placeholder="Search"
                                                    value={search}
                                                    onChange={(e) => {
                                                        // if (e.target.value.trim().length === 0) {
                                                        //     setLoading(true)
                                                        // }
                                                        setSearch(e.target.value)
                                                    }
                                                    }
                                                />
                                            }

                                        </div>
                                        <div className="d-flex align-items-center" style={{ gap: '0.8rem' }}>
                                            {filter === "zone" &&
                                                <div className="filter_tags_design_d2">
                                                    <ul className="p-0 m-0">
                                                        {filterApplyApiCall.zoneType.length > 0 &&
                                                            <li>
                                                                <div className="d-flex">
                                                                    <span className="black_text_d2">Zone Type:</span>{filterApplyApiCall.zoneType.join(", ")}

                                                                </div>
                                                                <button type="button"><img src={tagRomoveIcon} className="" alt=""
                                                                    onClick={() => {
                                                                        let tempFilterApply = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                                        let tempFilterApply2 = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                                        tempFilterApply.zoneType = []
                                                                        tempFilterApply2.zoneType = []
                                                                        setFilterApply(tempFilterApply2)
                                                                        setFilterApplyApiCall(tempFilterApply)
                                                                    }}
                                                                /> </button>
                                                            </li>
                                                        }

                                                    </ul>
                                                </div>
                                            }

                                            <div className='form_content_block--group' style={{ cursor: "pointer", width: "20rem" }}>
                                                <DateRangePicker
                                                    ref={datepickerRef}
                                                    startDate={dateRange.start}
                                                    endDate={dateRange.end}

                                                    initialSettings={{
                                                        containerClass: "custom-class-1",
                                                        alwaysShowCalendars: true,
                                                        startDate: dateRange.start,
                                                        endDate: dateRange.end,
                                                        locale: {
                                                            format: "DD/MM/YYYY",
                                                        },
                                                        maxDate: new Date(),
                                                        ranges: {
                                                            Today: [moment().toDate(), moment().toDate()],
                                                            Yesterday: [
                                                                moment().subtract(1, 'days').toDate(),
                                                                moment().subtract(1, 'days').toDate(),
                                                            ],
                                                            'Last 7 Days': [
                                                                moment().subtract(6, 'days').toDate(),
                                                                moment().toDate(),
                                                            ],
                                                            'Last 30 Days': [
                                                                moment().subtract(29, 'days').toDate(),
                                                                moment().toDate(),
                                                            ],
                                                            'This Month': [
                                                                moment().startOf('month').toDate(),
                                                                moment().endOf('month').toDate(),
                                                            ],
                                                            'Last Month': [
                                                                moment().subtract(1, 'month').startOf('month').toDate(),
                                                                moment().subtract(1, 'month').endOf('month').toDate(),
                                                            ],
                                                        },
                                                    }}

                                                    onCallback={(start, end, label) => {
                                                        // const diffDays = moment(end).diff(moment(start), "days");
                                                        // if (label === "Custom Range" && diffDays > 31) {
                                                        //     notifyfailure("Custom range cannot be greater than 31 days!");
                                                        // } else {
                                                        setDateRange({ start: start, end: end });
                                                        // setLabelName(label)
                                                        setApicall(!apiCall);
                                                        // }
                                                    }
                                                    }
                                                >
                                                    <div id="reportrange"
                                                        className={hasClass ? "daterange_back_shadow form_select basic d_flex justify_comtent_start align_items_center height_32 border_radius_6 width_196 " : "form_select basic d_flex justify_comtent_start align_items_center  height_32 border_radius_6 width_196"}

                                                        style={{ height: "3.6rem", borderColor: '#cbd5e1', width: "20rem", display: "flex", justifyContent: "center" }}
                                                    >
                                                        {/* <span className="pl_10">{labelName === "Custom Range" ? label : labelName}</span> */}
                                                        <span className="pl_10" style={{ fontFamily: "Poppins", fontSize: "13px", paddingTop: "2px", width: "19rem" }}>
                                                            {/* {label} */}
                                                            {dateRange.start.format('DD/MM/YYYY')} - {dateRange.end.format('DD/MM/YYYY')}
                                                        </span>
                                                        <i className="fa fa-caret-down"></i>
                                                    </div>
                                                </DateRangePicker>
                                            </div>


                                            {filter === "zone" &&
                                                <Dropdown ref={dropdownRef} show={filterShow}
                                                    onToggle={() => { setFilterShow(!filterShow) }}
                                                    className=""
                                                    autoClose={false}>
                                                    <div className="position-relative hover_effec_hide_show_d2">
                                                        <Dropdown.Toggle id="dropdown-autoclose-false">
                                                            <Button className="" icon={
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                    <path d="M12.5611 2H1.44995L5.8944 7.25556V10.8889L8.11662 12V7.25556L12.5611 2Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            }>
                                                                Filter
                                                                {filterApplyApiCall?.zoneType?.length > 0 &&
                                                                    <div className="selected_filter_tag_d2">
                                                                        <div>{filterApplyApiCall?.zoneType?.length}</div>
                                                                    </div>
                                                                }
                                                            </Button>
                                                        </Dropdown.Toggle>
                                                        {/* {filterApplyApiCall?.zoneType?.length > 0 &&
                                                            <div className="clear_filter_icon_d2"

                                                            >
                                                                <button type="button"> <img src={HoverCloseIcon} alt=""
                                                                    onClick={() => {
                                                                        setFilterApply({
                                                                            zoneType: []
                                                                        })
                                                                        setFilterApplyApiCall({
                                                                            zoneType: []
                                                                        })
                                                                        setFilterShow(false)
                                                                    }} />
                                                                </button>
                                                            </div>
                                                        } */}
                                                    </div>

                                                    <Dropdown.Menu>
                                                        <div className="filter_inner_heading_d2">

                                                            <p className="m-0">Zone Type</p>
                                                            <div className="checkbox_value_select_d2">
                                                                <div className="checkbox_active_design_d2">
                                                                    <input type="checkbox" name="zone_banner" id="zone_banner"
                                                                        checked={filterApply.zoneType.includes("Banner")}
                                                                        onChange={() => { handleFilterApply("zoneType", "Banner") }}
                                                                    />
                                                                    <label htmlFor="zone_banner" className="single_checkbox_select_d2">
                                                                        Banner
                                                                    </label>
                                                                </div>
                                                                <div className="checkbox_active_design_d2">
                                                                    <input type="checkbox" name="zone_rtb" id="zone_rtb"
                                                                        checked={filterApply.zoneType.includes("RTB")}
                                                                        onChange={() => { handleFilterApply("zoneType", "RTB") }}
                                                                    />
                                                                    <label htmlFor="zone_rtb" className="single_checkbox_select_d2">
                                                                        RTB
                                                                    </label>
                                                                </div>
                                                                <div className="checkbox_active_design_d2">
                                                                    <input type="checkbox" name="zone_vast" id="zone_vast"
                                                                        checked={filterApply.zoneType.includes("VAST")}
                                                                        onChange={() => { handleFilterApply("zoneType", "VAST") }} />
                                                                    <label htmlFor="zone_vast" className="single_checkbox_select_d2">
                                                                        VAST
                                                                    </label>
                                                                </div>

                                                            </div>
                                                            <hr />
                                                        </div>
                                                        <div className="filter_bottom_btns_d2 text-end">
                                                            <button className="reset" type='button' onClick={() => {
                                                                setFilterApply({
                                                                    zoneType: []
                                                                })
                                                                setFilterApplyApiCall({
                                                                    zoneType: []
                                                                })
                                                                setFilterShow(false)

                                                            }}>Reset</button>
                                                            <button className="apply" type='button'
                                                                onClick={() => {
                                                                    let tempdata = JSON.parse(JSON.stringify(filterApply));
                                                                    setFilterApplyApiCall(tempdata)
                                                                    setFilterShow(false)

                                                                }}
                                                                disabled={JSON.stringify(filterApplyApiCall) === JSON.stringify(filterApply)}
                                                            >Apply</button>
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            }
                                        </div>
                                    </>

                                }
                            </div>
                        </div>
                        <div className="table_content--box --new_layout_table_design table_empty_screen_d2 user_sync_table">
                            {loading && !initialLoad && !tabChangeLoad &&
                                <div className="table_new_loader_d2">
                                    <img src={FullLoader} className="img-fluid" alt="" />
                                </div>
                            }

                            {initialLoad || tabChangeLoad ?
                                <TableLoader />

                                :
                                filter === "date" ?
                                    <div className="user_sync_table_total">
                                        <Table
                                            columns={columnsDate}
                                            pageSize={100}
                                            dataSource={filteredData}
                                            onChange={handleTableChange}
                                            pagination={false}
                                            rowKey={(record) => record.id}
                                            locale={locale}
                                            showSorterTooltip={false}
                                            scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 44rem' }}
                                            summary={() => (
                                                data.length > 0 && search.trim().length === 0 ? (
                                                    <Table.Summary fixed >
                                                        <Table.Summary.Row className="test" >
                                                            {columnsDate?.flatMap(col => col.children ? col.children : [col])?.map((column, index) => (
                                                                <Table.Summary.Cell key={column?.key}
                                                                    className={index === 0 ? "summary_total" : ""}
                                                                >
                                                                    {index === 0 ? 'TOTAL' :
                                                                        Object.keys(total).length > 0 ?
                                                                            (total[column.key] !== undefined && total[column.key] !== null && total[column.key] !== "-" && total[column.key] !== "") ?
                                                                                total[column.key] : "-" : "-"}
                                                                </Table.Summary.Cell>
                                                            ))}
                                                        </Table.Summary.Row>
                                                    </Table.Summary>
                                                ) : null
                                            )}
                                        />
                                    </div>
                                    :
                                    <div className={data.length === 0 ? "user_sync_table_total --no_data_new_layout_design" : "user_sync_table_total"}>
                                        <Table
                                            columns={columnsZone}
                                            pageSize={100}
                                            dataSource={filteredData}
                                            onChange={handleTableChange}
                                            pagination={false}
                                            rowKey={(record) => record.id}
                                            locale={locale}
                                            showSorterTooltip={false}
                                            scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: data.length === 0 ? 'calc(100vh - 35.1rem' : 'calc(100vh - 43.7rem' }}
                                            summary={() => (
                                                data.length > 0 && search.trim().length === 0 ? (
                                                    <Table.Summary fixed >
                                                        <Table.Summary.Row className="test" >
                                                            {columnsZone?.flatMap(col => col.children ? col.children : [col])?.map((column, index) => (
                                                                <Table.Summary.Cell key={column?.key}
                                                                    className={index === 0 ? "summary_total" : ""}
                                                                >
                                                                    {index === 0 ? 'TOTAL' :
                                                                        Object.keys(total).length > 0 ?
                                                                            (total[column.key] !== undefined && total[column.key] !== null && total[column.key] !== "-" && total[column.key] !== "") ?
                                                                                total[column.key] : "-" : "-"}
                                                                </Table.Summary.Cell>
                                                            ))}
                                                        </Table.Summary.Row>
                                                    </Table.Summary>
                                                ) : null
                                            )}
                                        />
                                    </div>


                            }

                            {filteredData?.length > 0 && !tabChangeLoad && !initialLoad &&
                                <Row className="custom_pagination--container">
                                    <Col span={6}>
                                        <div className="form_content_block--group mb_0">
                                            <Select
                                                className='form_select basic sm no_search'
                                                value={page.pageSize}
                                                onChange={handlePageSizeChange}
                                                style={{ width: 80 }}
                                                showSearch={false}
                                                options={[
                                                    { value: 10, label: 10 },
                                                    { value: 20, label: 20 },
                                                    { value: 50, label: 50 },
                                                    { value: 100, label: 100 },
                                                ]} />
                                            <label className='custom_pagination--label'>
                                                items per page
                                            </label>
                                        </div>
                                    </Col>
                                    <Col span={6}>
                                        <span className="custom_pagination--total-text">
                                            {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                        </span>
                                    </Col>
                                    <Col span={6}>
                                        <Pagination
                                            current={page.current}  // Pass individual props instead of spreading them
                                            pageSize={page.pageSize}
                                            total={page.total}
                                            onChange={handlePageChange}
                                            showSizeChanger={false}
                                            itemRender={itemRender}
                                            className="custom_pagination" />
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div>
                </div>

            </div>


        </>
    );
};

export default UserSyncReport;
